import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';
import { ExportFileFormat } from '../../../export-task.enum';
import { ProcessorPropertyAVETypes } from '../processor-types.enums';
import { ExportPropertyTypeTransformParams } from '../processor-types.interface';
import { OrderStatusERPEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/order-status-erp.enum';
import isEmpty from 'lodash-es/isEmpty';

export const status = (status: StatusEnum | string | number): ExportPropertyTypeTransformParams => ({
  __for_processor: true,
  formats: [ExportFileFormat.Excel, ExportFileFormat.JSON, ExportFileFormat.CSV],
  type: ProcessorPropertyAVETypes.StatusERP,
  transform: () => {
    switch (status) {
      case StatusEnum.INACTIVE: return 'Inactivo';
      case StatusEnum.ACTIVE: return 'Activo';
      case StatusEnum.ORDER_IN_PROGRESS: return 'En progreso';
      case StatusEnum.ORDER_APPROVED: return 'Aprobado';
      case StatusEnum.ORDER_REJECTED: return 'Rechazado';
      case StatusEnum.ORDER_PARTIAL_APPROVED: return 'Parcialmente aprobado';
      case StatusEnum.ORDER_DELIVERED: return 'Entregado';
      case StatusEnum.ORDER_PARTIAL_DELIVERED: return 'Parcialmente entregado';
      case StatusEnum.ORDER_DELIVERY_REJECTED: return 'Rechazo entrega';
      default: return null;
    }
  },
  fallback: status,
});

export const statusERP = (status: OrderStatusERPEnum | string | number): ExportPropertyTypeTransformParams => ({
  __for_processor: true,
  formats: [ExportFileFormat.Excel, ExportFileFormat.JSON, ExportFileFormat.CSV],
  type: ProcessorPropertyAVETypes.StatusERP,
  transform: () => {
    switch (status) {
      case OrderStatusERPEnum.ORDER_PENDING: return 'Pendiente envío a ERP';
      case OrderStatusERPEnum.ORDER_SEND: return 'Enviado a ERP';
      case OrderStatusERPEnum.ORDER_RECEIVED: return 'Recibido por ERP';
      case OrderStatusERPEnum.ORDER_CREATED: return 'Creado en ERP';
      case OrderStatusERPEnum.ORDER_ERROR: return 'Error enviando a ERP';
      case OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE: return 'Mod. pendiente de replicar';
      case OrderStatusERPEnum.ORDER_ERROR_ERP: return 'Error en ERP';
      default: {
        if (isEmpty(status)) return 'Pendiente envío a ERP'
        return null;
      };
    }
  },
  fallback: status,
});
